<template>
  <w-icon-wrapper
    :height="21.36"
    :width="24"
    viewBox="0 0 24 21.36"
    icon-name="w-icon-price-upload"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rechteck_5881"
          data-name="Rechteck 5881"
          width="22.5"
          height="24"
          transform="translate(0 0)"
          fill="none"
        />
      </clipPath>
    </defs>
    <g
      id="Gruppe_27132"
      data-name="Gruppe 27132"
      clip-path="url(#clip-path)"
    >
      <path
        id="Pfad_59700"
        data-name="Pfad 59700"
        d="M16.5,0H2.5V8.915a1,1,0,0,0,2,0V2h10V8h6V22H4.5V17.04a1,1,0,0,0-2,0V24h20V6Zm0,6V2.83L19.67,6Z"
        fill="currentColor"
      />
      <path
        id="Pfad_59701"
        data-name="Pfad 59701"
        d="M14.974,12.495a.957.957,0,0,0-.078-.078L11.9,9.451a1.027,1.027,0,0,0-1.438-.006.988.988,0,0,0-.006,1.414l1.307,1.3H1.017a1,1,0,1,0,0,2H11.752L10.41,15.438a.989.989,0,0,0-.02,1.414,1.028,1.028,0,0,0,1.437.02l3.85-3.68Z"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconPriceUpload' };
</script>